import { useState } from "react"
import ActionMenu, {
  type ActionMenuItemProps,
} from "@/v2-backoffice-client/components/actionMenu"
import LicensePlanUpdateDialog from "@/v2-backoffice-client/license/plan/update/LicensePlanUpdateDialog"
import type { LicensePlanFragment } from "@/v2-backoffice-client/license/plan/__types__/license.plan.fragment"

export type LicensePlanUpdateMenuItemProps = Omit<
  ActionMenuItemProps,
  "onClick"
> & {
  plan: LicensePlanFragment
}

// The board row menu's trigger for the Update License dialog (the license
// panel's toolbar opens the same dialog via a direct button).
function LicensePlanUpdateMenuItem(props: LicensePlanUpdateMenuItemProps) {
  const { plan, children, ...menuItemProps } = props
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <ActionMenu.Item
        iconSrc="edit"
        data-feature-code="UI_BackofficeLicensePlan_Row_Mapping"
        onSelect={(e) => {
          e.preventDefault()
          setIsOpen(true)
        }}
        {...menuItemProps}
      >
        {children ?? "Update License"}
      </ActionMenu.Item>

      {/* Mounted per open so the fields re-seed from the row every time. */}
      {isOpen && (
        <LicensePlanUpdateDialog
          plan={plan}
          open={isOpen}
          onOpenChange={setIsOpen}
        />
      )}
    </>
  )
}

export default LicensePlanUpdateMenuItem
